const UserManagement = () => import("@/pages/user/index");
const UserList = () => import("@/pages/user/list")
const DetailsManagement = () => import("@/pages/user/details")
const DetailsVisit = () => import("@/pages/user/details/visit")
const DetailsPass = () => import("@/pages/user/details/pass")

export default [
    {
        path: '/user-management',
        component: UserManagement,
        children: [
            {
                path: '',
                component: UserList,
                meta: [
                    {
                        name: '用户管理',
                        url: '/user-management'
                    }
                ]
            },
            {
                path: 'user-details/get/:id',
                component: DetailsManagement,
                meta: [
                    {
                        name: '用户管理',
                        url: '/user-management'
                    },
                    {
                        name: '用户详情',
                        url: '/get',
                    },
                ]
            },
            {
                path: 'user-details/visit/get/:id',
                component: DetailsVisit,
                meta: [
                    {
                        name: '用户管理',
                        url: '/user-management'
                    },
                    {
                        name: '用户详情',
                        url: '/user-management/user-details/get/:id'
                    },
                    {
                        name: '拜访申请记录',
                        url: 'visit/get'
                    },
                ]
            },
            {
                path: 'user-details/pass/get/:id',
                component: DetailsPass,
                meta: [
                    {
                        name: '用户管理',
                        url: '/user-management'
                    },
                    {
                        name: '用户详情',
                        url: '/user-management/user-details/get/:id'
                    },
                    {
                        name: '放行申请记录',
                        url: 'pass/get'
                    },
                ]
            }
        ]
    }
]


// WEBPACK FOOTER //
// ./src/router/user.js